import * as React from 'react';
import Input from '../../../input';
function FilterSearch(props) {
    const { value, onChange, filterSearch, filterPlaceholder, tablePrefixCls, locale } = props;
    if (!filterSearch) {
        return null;
    }
    return (<div className={`${tablePrefixCls}-filter-dropdown-search`}>
            <Input placeholder={filterPlaceholder || locale.filterSearchPlaceholder} onChange={onChange} value={value} 
    // for skip min-width of input
    // htmlSize={1}
    className={`${tablePrefixCls}-filter-dropdown-search-input`}/>
        </div>);
}
export default FilterSearch;
